import { render, staticRenderFns } from "./PeriodPriceCreateDialog.vue?vue&type=template&id=4db44e0e&scoped=true"
import script from "./PeriodPriceCreateDialog.vue?vue&type=script&lang=js"
export * from "./PeriodPriceCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./PeriodPriceCreateDialog.vue?vue&type=style&index=0&id=4db44e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db44e0e",
  null
  
)

export default component.exports